module.exports = __webpack_public_path__ + "static/shakoy-0062348ebf5e0486490a18a6bff91188.jpg";